import Image from 'next/image';
import { FC } from 'react';
import { StyledAnimatedArrow } from './AnimatedArrow.styles';
import { IAnimatedArrow } from './AnimatedArrow.type';

const AnimatedArrow: FC<IAnimatedArrow> = ({ isActive, width, height, ...otherProps }) => {
	return (
		<StyledAnimatedArrow isActive={isActive} {...otherProps}>
			<Image quality={100} src='/assets/divers/menu-arrow.svg' alt='' width={width} height={height} />
		</StyledAnimatedArrow>
	);
};

export { AnimatedArrow };
